<div class="typing is-typing-init is-typing-active">
    <span class="typing__bullet"></span>
    <span class="typing__bullet"></span>
    <span class="typing__bullet"></span>
</div>
